// Copyright (c) 2026 Goffy. This file belongs to Goffy. All Rights Reserved.

export function ensureTournamentGamesSelected(
  selectedGameIds: Iterable<string>,
  tournamentGameIds: Iterable<string>,
  excludedGameIds?: ReadonlySet<string>
): Set<string> {
  const isExcluded = (gameId: string) =>
    excludedGameIds?.has(gameId.trim().toLowerCase()) ?? false;
  const next = new Set<string>();
  Array.from(selectedGameIds).forEach((gameId) => {
    if (typeof gameId === 'string' && gameId.length > 0 && !isExcluded(gameId)) {
      next.add(gameId);
    }
  });
  Array.from(tournamentGameIds).forEach((gameId) => {
    if (typeof gameId === 'string' && gameId.length > 0 && !isExcluded(gameId)) {
      next.add(gameId);
    }
  });
  return next;
}

export function toggleSelectableGame(
  selectedGameIds: Iterable<string>,
  gameId: string,
  lockedGameIds: ReadonlySet<string>
): Set<string> {
  const next = new Set<string>(Array.from(selectedGameIds));
  if (lockedGameIds.has(gameId)) {
    return next;
  }
  if (next.has(gameId)) {
    next.delete(gameId);
  } else {
    next.add(gameId);
  }
  return next;
}
